import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';

import {
    DropzoneComponent, DropzoneDirective,
    DropzoneConfigInterface
} from 'ngx-dropzone-wrapper';

import { ImageListModalComponent } from '../image-list-modal';

@Component({
    selector: 'app-drop-image-list-modal',
    templateUrl: './drop-image-list-modal.component.html',
    styleUrls: ['./drop-image-list-modal.component.scss']
})

export class DropImageListModalComponent {
    @ViewChild(ImageListModalComponent) imageList: ImageListModalComponent;
    @Output() filesChanged = new EventEmitter();
    @Input() disabled: boolean = false;
    @Input() canDelete = true;
    @Input() config: DropzoneConfigInterface = {
        maxFilesize: 50,
        acceptedFiles: '.png,.jpg',
        paramName: 'file'
    };
    filesToDelete = [];
    fileIndicationLabel: string;
    constructor(private _sanitizer: DomSanitizer, ) {
        let maxSize: string = `(Máximo: ${this.config.maxFilesize}MB)`;
        this.fileIndicationLabel = `${this.config.acceptedFiles} ${maxSize}`;
    }
    dropFilesHandler(e) {
        this.imageList.files = this.imageList.files.concat(e.data.map(file => {
            file.data = this._sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
            return file;
        }));
        this.filesChanged.emit(this.imageList.files);
    }
    deleteFile(file) {
        this.filesToDelete.push(file);
        this.filesChanged.emit(this.imageList.files);
    }
    get files() {
        return this.imageList.files;
    }
    set files(data) {
        this.imageList.files = data;
        this.filesChanged.emit(this.imageList.files);
    }
    get filesToUpload() {
        return this.imageList.files.filter(file => {
            return (file instanceof File);
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/drop-image-list-modal/drop-image-list-modal.component.ts